export const delayReasons = [
	{
		display: 'Truck Wait',
		value: 'truckWait',
		type: 'BOTH',
	},
	{
		display: 'Pause Load',
		value: 'pauseLoad',
		type: 'LOADING',
	},
	{
		display: 'Arms Down',
		value: 'armsDown',
		type: 'LOADING',
	},
	{
		display: 'Blend Issue',
		value: 'blendIssue',
		type: 'LOADING',
	},
	{
		display: 'Printer Issue',
		value: 'printerIssue',
		type: 'LOADING',
	},
	{
		display: 'Allocation Issue',
		value: 'allocationIssue',
		type: 'LOADING',
	},
	{
		display: 'Truck Issue',
		value: 'truckIssue',
		type: 'BOTH',
	},
	{
		display: 'Rack Issue',
		value: 'rackIssue',
		type: 'LOADING',
	},
	{
		display: 'Gauging',
		value: 'gauging',
		type: 'LOADING',
	},
	{
		display: 'Training',
		value: 'training',
		type: 'BOTH',
	},
	{
		display: 'Certification',
		value: 'certification',
		type: 'LOADING',
	},
	{
		display: 'Car in Way',
		value: 'carInWay',
		type: 'UNLOADING',
	},
	{
		display: 'Station Closed',
		value: 'stationClosed',
		type: 'UNLOADING',
	},
	{
		display: 'Move Truck',
		value: 'moveTruck',
		type: 'BOTH',
	},
	{
		display: 'Station Construction',
		value: 'stationConstruction',
		type: 'UNLOADING',
	},
	{
		display: 'Retain',
		value: 'retain',
		type: 'UNLOADING',
	},
	{
		display: 'Diversion',
		value: 'diversion',
		type: 'UNLOADING',
	},
	{
		display: 'Flapper Issue',
		value: 'flapperIssue',
		type: 'UNLOADING',
	},
	{
		display: 'Single Hose',
		value: 'singleHose',
		type: 'BOTH',
	},
	{
		display: 'Breakdown',
		value: 'breakdown',
		type: 'BOTH',
	},
	{
		display: 'Restroom',
		value: 'restroom',
		type: 'BOTH',
	},
	{
		display: 'Lunch',
		value: 'lunch',
		type: 'BOTH',
	},
	{
		display: 'Break',
		value: 'break',
		type: 'BOTH',
	},
	{
		display: 'Waiting on Dispatch',
		value: 'waitingOnDispatch',
		type: 'BOTH',
	},
	{
		display: 'Other (Explain)',
		value: 'other',
		type: 'BOTH',
	},
];
export const loadingDelayReason = delayReasons.filter((delayReason) => {
	return delayReason.type === 'LOADING' || delayReason.type === 'BOTH';
});

export const unloadingDelayReason = delayReasons.filter((delayReason) => {
	return delayReason.type === 'UNLOADING' || delayReason.type === 'BOTH';
});
